import { Show } from "solid-js"
import { formatDelay } from "../lib/format"
import { app } from "../store/app"

export function TrackerHud() {
  return (
    <Show when={app.view() === "vehicle" && app.selectedVehicle()}>
      {(vehicle) => {
        const color = () => `#${app.routeColor(vehicle().routeId, vehicle().routeColor)}`
        const pct = () => (vehicle().progress != null ? Math.round(vehicle().progress! * 100) : null)
        return (
          <div id="tracker-hud">
            <div class="tracker-top">
              <span class="tracker-badge" style={{ background: color() }}>
                {vehicle().routeName || "?"}
              </span>
              <div class="tracker-copy">
                <div class="tracker-title">{vehicle().headsign || "in service"}</div>
                <div class="tracker-sub">
                  {formatDelay(vehicle().delay)}
                  {pct() != null ? ` · ${pct()}% of trip` : ""}
                </div>
              </div>
            </div>
            <div class="tracker-next">
              <div class="label">next stop</div>
              <div class="value">{vehicle().nextStopName || "—"}</div>
            </div>
            <div class="tracker-bar">
              <div
                class="tracker-fill"
                style={{ width: `${pct() ?? 0}%`, background: color() }}
              />
            </div>
          </div>
        )
      }}
    </Show>
  )
}
